import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import {GoogleMap, MapInfoWindow} from "@angular/google-maps";
import {LogisticsVehicle} from "../../../../logistics-vehicle/models/logistics-vehicle.model";
import {AccountsHttpService} from "../../../../account/angular/services/accounts-http.service";
import * as _ from "lodash";
import {DepotsHttpService} from "../../../../depots/angular/services/depots-http.service";

require('./agents-map.scss');
@Component({
  standalone: false,
  selector: 'app-agents-map',
  templateUrl: './agents-map.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentsMapComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() agents: AgentModel[];
  @Input() branchIds: string[];
  @Input() logisticsVehicles: LogisticsVehicle[];
  @Output() agentSelectEvent = new EventEmitter<AgentModel>();

  public center!: google.maps.LatLngLiteral;
  public zoom: number = 13;
  public agentMarkers: {
    position: { lat: any; lng: any; },
    options: {
      icon: any,
      zIndex: number
    },
    index: number
  }[] = [];
  public accountMarkers: any = [];
  public depotMarkers: any = [];
  public mapOptions: google.maps.MapOptions;

  @ViewChild('agentsMap', {static: false}) agentsMap!: GoogleMap;

  constructor(@Inject('mapsCommonService') private mapsCommonService, @Inject(AccountsHttpService) private accountsHttpService: AccountsHttpService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef, @Inject(DepotsHttpService) private depotsHttpService: DepotsHttpService) {
  }

  ngOnInit() {
    this.center = this.mapsCommonService.getSiteLocation();

    this.mapOptions = {
      styles: this.mapsCommonService.getDefaultStyle(),
    }
    this.initAgentMarkers();
    this.initGeneralMarkers();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agents && !changes.agents.isFirstChange()) {
      this.initAgentMarkers();
    }

    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      this.initGeneralMarkers();
    }
  }

  ngAfterViewInit() {
    this.centerMap();
  }

  private initAgentMarkers() {
    this.agentMarkers = [];

    if (!this.agents?.length) {
      return;
    }
    this.agents.forEach((agent, index) => {
      const agentIcon = this.mapsCommonService.createAgentCustomIcon(agent, agent.displayColor, 30);
      const agentMarker = {
        position: {
          lat: agent.lastKnownLocation.coordinates.latitude,
          lng: agent.lastKnownLocation.coordinates.longitude
        },
        options: {
          icon: {url: agentIcon},
          zIndex: 10
        },
        agent: agent,
        index: index + 1
      }

      this.agentMarkers.push(agentMarker);
    })

    this.centerMap();

  }

  private initGeneralMarkers() {
    this.accountsHttpService.getAll({branchIds: this.branchIds, isDemand: true, isActive: true}).subscribe((res) => {

      this.accountMarkers = [];

      if (!res.list?.length) {
        return;
      }

      res.list.forEach((account, index) => {
        const accountMarker = {
          position: {
            lat: account.address.location.latitude,
            lng: account.address.location.longitude
          },
          options: {
            icon: {
              url: 'assets/images/icons/map/account.svg',
              scaledSize: new google.maps.Size(42, 42)
            },
            zIndex: 10
          },
          account: account,
          index: index + 1
        }

        this.accountMarkers.push(accountMarker);
        this.cdr.detectChanges();

      })

    })

    this.depotsHttpService.getAll({branchIds: this.branchIds})
      .subscribe((res) => {

        this.depotMarkers = [];

        if (!res.list?.length) {
          return;
        }

        res.list.forEach((depot, index) => {
          const depotMarker = {
            position: {
              lat: depot.address.location.latitude,
              lng: depot.address.location.longitude
            },
            options: {
              icon: this.mapsCommonService.buildDepotTaskIcon(),
              zIndex: 10
            },
            depot: depot,
            index: index + 1
          }

          this.depotMarkers.push(depotMarker);
          this.cdr.detectChanges();

        })

      })
  }

  centerMap() {
    if (!!this.agentMarkers?.length && this.agentsMap) {
      const bounds = new google.maps.LatLngBounds();
      this.agentMarkers.forEach(marker => {
        bounds.extend(new google.maps.LatLng(marker.position.lat, marker.position.lng));
      });

      this.accountMarkers.forEach(marker => {
        bounds.extend(new google.maps.LatLng(marker.position.lat, marker.position.lng));
      });
      this.agentsMap.fitBounds(bounds);
    }
  }


  public openInfoWindow(marker, infoWindow: MapInfoWindow): void {
    infoWindow.open(marker);
  }

  public closeInfoWindows(infoWindow: MapInfoWindow): void {
    infoWindow.close();
  }

  public onAgentClick(agentMarker) {
    this.agentSelectEvent.emit(agentMarker.agent);
  }


}
